import { get, post, patch } from '../../networkClient';
import { Path } from '../path';

export function getUnitIndex({ communityId, moveInDate }) {
  let url = `${Path.GET_COMMUNITY_UNITS(communityId)}?availableOnly=true`;
  if (moveInDate) {
    const d = new Date(moveInDate);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const moveIn = `${d.getFullYear()}-${month >= 10 ? month : `0${month}`}-${
      day >= 10 ? day : `0${day}`
    }`;
    url += `&moveInDate=${moveIn}`;
  }
  return get(url, null, null, true, true);
}

export function getUnitPricingMatrix({ communityId, unitName, siteId }) {
  let url = `${Path.GET_COMMUNITY_UNIT(communityId)}?unitName=${encodeURIComponent(
    unitName
  )}`;
  if (siteId) url += `&siteId=${encodeURIComponent(siteId)}`;
  return get(url, null, null, true, true);
}

export function getInboxMetaData({ leadId }) {
  return get(`${Path.LEAD_INBOX}${leadId}`, null, null, true, true);
}

export function getTimeSlotsApi({ communityId, leadId, tourType }) {
  return get(
    Path.GET_TIMESLOTS,
    { leadId, communityId, tourType },
    null,
    true,
    true
  );
}

export function createTourApi({ id, data }) {
  return post(`${Path.CREATE_TOUR}`, data, undefined, undefined, true);
}

export function deleteTourApi({ tourId, cancelReason }) {
  return post(
    `${Path.DELETE_TOUR}`,
    { tourId: tourId, cancelReason },
    undefined,
    undefined,
    true
  );
}

export function confirmTourApi({ id }) {
  return get(
    `${Path.GET_TOUR_CONFIRMATION}?tourId=${id}`,
    null,
    null,
    true,
    true
  );
}

export function createTourNotesApi({ notesPayload }) {
  return post(
    `${Path.CREATE_TOUR_NOTES}`,
    { ...notesPayload },
    undefined,
    undefined,
    true
  );
}

export function getNotesByTourIdApi({ id }) {
  return get(
    `${Path.GET_TOUR_NOTES_BY_TOURID}?tourId=${id}`,
    null,
    null,
    true,
    true
  );
}
export function changeStageApi({ stagePayload }) {
  return patch(
    `${Path.UPDATE_STAGE}`,
    { ...stagePayload },
    undefined,
    undefined,
    true,
    true
  );
}

export function getPricingListings({ apartmentPayload }) {
  const { apartmentId, moveInDate } = apartmentPayload;
  return getUnitIndex({ communityId: apartmentId, moveInDate });
}
